
const EngagementsIntro = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-white to-fabre-lightgray">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl font-heading font-bold mb-6 text-fabre-gray">
            Une entreprise engagée pour l'environnement
          </h2>
          <div className="w-24 h-1.5 bg-gradient-to-r from-fabre-green to-fabre-teal mx-auto mb-8 rounded-full"></div>
          <p className="text-xl text-gray-600 leading-relaxed">
            Chez Groupe Fabre Environnement, nos engagements guident chacune de nos actions. 
            Nous croyons qu'une gestion responsable des déchets est essentielle pour préserver notre planète pour les générations futures.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EngagementsIntro;
